import { render, staticRenderFns } from "./PeopleFormPage.vue?vue&type=template&id=5b056856"
import script from "./PeopleFormPage.vue?vue&type=script&lang=js"
export * from "./PeopleFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports